import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { ConfigBaseFilter, ListLayout, SimpleConfigBaseFilter } from 'gung-list';
import { MetadataService, Order } from 'gung-standard';
import { JeevesOrderListConfigService } from 'gung-standard-jeeves';
import { CarLinerOrderCardListComponent } from '../components/car-liner-order-card-list/car-liner-order-card-list.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerOrderListConfigService extends JeevesOrderListConfigService {
  protected includeRows = false;

  getItems() {
    return super.getItems().pipe(
      map(orders => {
        return orders.filter(o => o.extra.oh.ordstat !== 90);
      })
    );
  }

  getFilters(): ConfigBaseFilter<Order>[] {
    const filters = super.getFilters();
    const indexFilterDeliveryDate = filters.findIndex(filter => filter.getName() === 'EXPECTED_DELIVERY_DATE');
    if (indexFilterDeliveryDate > -1) {
      filters.splice(indexFilterDeliveryDate, 1);
    }

    const indexOrderStatus = filters.findIndex(filter => filter.getName() === 'ORDER_STATUS');
    if (indexOrderStatus > -1) {
      filters.splice(indexOrderStatus, 1, new CarLinerOrderStatusFilter(this.translationService, this.metadataService));
    }
    return filters;
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        ...super.getLayouts()[0],
        getListItemComponent: () => CarLinerOrderCardListComponent
      }
    ];
  }
}

class CarLinerOrderStatusFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected translateService: TranslateService, protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'ORDER_STATUS';
  }

  getOptionIds(item: Order): string[] {
    if (item.extra.oh.ordstat < 13) {
      return ['ENTRY_IN_PROGRESS'];
    }
    if (item.extra.oh.ordstat === 13) {
      return ['ENTERED'];
    }
    if (item.extra.oh.ordstat >= 14 && item.extra.oh.ordstat <= 50) {
      return ['PICKING_IN_PROGRESS'];
    }
    if (item.extra.oh.ordstat === 70) {
      return ['INVOICED'];
    }

    return ['UNDEFINED'];
  }

  getOptionName(key: string): string {
    return this.translateService.instant(key);
  }
}
